<template>
  <v-dialog :model-value="dialogValue" width="720" persistent>
    <v-card>
      <v-card-title class="d-flex justify-space-between align-center">
        <div class="text-h5">Pievienot Izlasei</div>
        <v-icon icon="fa-regular fa-xmark" :size="24" flat @click="$emit('close')" />
      </v-card-title>
      <v-divider />
      <v-card-text>
        <div v-if="loadingData" class="d-flex justify-center"><v-progress-circular indeterminate /></div>
        <div v-else>
          <v-list active-class="selected-playlist">
            <v-list-item
              v-for="(playlist, idx) in playlistsStore.playlists"
              :key="idx"
              :value="playlist.slug"
              prepend-icon="fa-regular fa-folder"
              class="my-1"
              @click="selectPlaylist(playlist)"
            >
              <div class="d-flex justify-space-between">
                <div>{{ playlist.name }}</div>
                <div @click="removePlaylist(playlist)">
                  <v-icon icon="fa-solid fa-trash" :size="15" />
                  <v-tooltip text="Izdzēst izlasi" activator="parent" location="left" />
                </div>
              </div>
            </v-list-item>
          </v-list>
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions class="d-flex justify-space-between">
        <v-btn @click="newPlaylistModal = true">
          <UserNewPlaylistModal :dialog-value="newPlaylistModal" @close="newPlaylistModal = false" />
          <v-icon icon="fa-regular fa-folder-plus" :size="20" />
          <v-tooltip text="Jauna izlase" activator="parent" />
        </v-btn>
        <v-btn
          class="add-playlist-button"
          variant="tonal"
          rounded="pill"
          :disabled="selectedPlaylist === null"
          @click="addProductToPlaylist()"
        >
          Pievienot
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import usePlaylistsStore from "~/stores/playlistsStore"
import { useSnackbarStore } from "~/stores/snackBarStore"
import type { PlaylistType } from "~/types/schema/index"

export default {
  props: {
    dialogValue: {
      required: true,
      type: Boolean,
    },

    productData: {
      required: true,
      type: Object as PropType<{ identifier: string; type: string }>,
    },
  },

  emits: ["close"],

  setup() {
    const snackbarStore = useSnackbarStore()
    const playlistsStore = usePlaylistsStore()
    return {
      playlistsStore,
      snackbarStore,
    }
  },

  data() {
    return {
      loadingData: true as boolean,
      selectedPlaylist: null as PlaylistType | null,
      newPlaylistModal: false as boolean,
    }
  },

  watch: {
    dialogValue() {
      this.selectedPlaylist = null
    },
  },

  created() {
    this.playlistsStore.fetchPlaylists({
      successCallback: this.successPlaylistsFetch,
      errorCallback: this.errorPlaylistsFetch,
    })
  },

  methods: {
    removePlaylist(playlist: PlaylistType) {
      this.playlistsStore.deletePlaylist({ slug: playlist.slug })
    },

    addProductToPlaylist() {
      if (this.selectedPlaylist) {
        const playlistSlug = this.selectedPlaylist.slug
        const identifier = this.productData.identifier
        const type = this.productData.type
        this.playlistsStore.addToPlaylist({
          playlistSlug,
          identifier,
          type,
          successCallback: this.successPlaylistAdd,
          errorCallback: this.errorPlaylistAdd,
        })
      }
    },

    selectPlaylist(playlist: PlaylistType) {
      this.selectedPlaylist = playlist
    },

    successPlaylistAdd() {
      this.$emit("close")
      this.selectedPlaylist = null
      this.snackbarStore.showMessage({
        type: "success",
        text: "Veiksmīgi pievienots izlasei",
      })
    },

    errorPlaylistAdd(ctx: any) {
      this.selectedPlaylist = null
      const alertText = ctx.status === 422 ? "Produkts jau ir izvēlētajā izlasē" : "Notika kļūda pievienošanas procesā"
      this.snackbarStore.showMessage({
        type: "error",
        text: alertText,
      })
    },

    successPlaylistsFetch() {
      this.loadingData = false
    },

    errorPlaylistsFetch(context: any) {
      this.loadingData = false
      console.error(context)
    },
  },
}
</script>

<style lang="sass">
.add-playlist-button
  width: 120px
  background: #F9D805
  text-transform: none
  font-weight: 700
  line-height: 20px
  font-size: 16px
  letter-spacing: 0.1px !important
.selected-playlist
  background: rgba(0, 0, 0, 0.06)
</style>
